import { render, staticRenderFns } from "./EditVersion.vue?vue&type=template&id=cb0f3a6e&scoped=true"
import script from "./EditVersion.vue?vue&type=script&lang=ts"
export * from "./EditVersion.vue?vue&type=script&lang=ts"
import style0 from "./EditVersion.vue?vue&type=style&index=0&id=cb0f3a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0f3a6e",
  null
  
)

export default component.exports